<template>
  <ul>
    <li v-for="(item, index) in list" @click="jump(item)" :key="index">
      <div class="list">
        <img :src="item.coverPic || item.pic || item.coverPicUrl" alt="" />
        <div>
          <div>{{ item.title || item.name || item.courseName }}</div>
          <p>
            <span style="margin-right: .2rem">
              {{ item.userName || item.userNickName }}
            </span>
            <span>{{ item.userDuty || item.userDuties || item.duties }}</span>
          </p>
          <p>
            {{ item.userCompanyName || item.userCompany || item.hospitalName }}
          </p>
        </div>
      </div>
    </li>
    <!--<li>-->
    <!--<div class="list big">-->
    <!--<img src="//cdn.yxvzb.com/img/PCzhinanimgleft1017.png" alt="">-->
    <!--<div class="bd">-->
    <!--<span class="bs1">儿科治疗全攻略</span>-->
    <!--<span class="bs2">订阅：1306人</span>-->
    <!--</div>-->
    <!--</div>-->
    <!--</li>-->
  </ul>
</template>
<script>
export default {
  name: '',
  props: {
    list: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  methods: {
    jump(item) {
      this.$router.push({
        name: 'courseDetail',
        params: {
          id: item.id
        }
      });
    }
  },
  computed: {},
  components: {},
  mounted() {}
};
</script>
<style lang="less" scoped>
.hidenText() {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    margin-bottom: 0.8rem;
    .list {
      img {
        display: block;
        width: 4.533rem;
        height: 2.56rem;
        border-radius: 0.1rem;
        margin-bottom: 0.1rem;
      }
      > div {
        width: 4.533rem;
        div {
          font-size: 0.3733rem;

          .hidenText();
        }
      }

      p {
        font-size: 0.32rem;
        color: #999;
        line-height: 1.3;
        .hidenText();
      }
    }
    .big {
      width: 100%;
      * {
        font-size: 0.3733rem;
      }
      img {
        width: 9.2rem;
        height: 4.4rem;
      }
      .bd {
        display: flex;
        justify-content: space-between;
        .bs1 {
        }
        .bs2 {
          color: #999;
        }
      }
    }
  }
}
</style>
